import { adminRequestsTyped } from "@/api/(requests)/adminTyped";

export type Practice = {
  general_email: string;
  name: string;
};

export async function getPracticeList(): Promise<Practice[]> {
  return adminRequestsTyped.fetch_all_practices();
}
